import deepFreeze from 'deep-freeze';
import serviceFactory from '@/services/serviceFactory';

export const ENDPOINTS = deepFreeze({
    SALES_STATS: {
        URI: () => '/api/v1/producer-product-categories/{{id}}/sales-stats',
        methods: ['get'],
    },
    CLICKS_STATS: {
        URI: () => '/api/v1/producer-product-categories/{{id}}/clicks-stats',
        methods: ['get'],
    },
    IMPRESSIONS_STATS: {
        URI: () => '/api/v1/producer-product-categories/{{id}}/impressions-stats',
        methods: ['get'],
    },
    SALES_CHART: {
        URI: () => '/api/v1/producer-product-categories/{{id}}/sales-chart',
        methods: ['get'],
    },
    TRAFFIC_CHART: {
        URI: () => '/api/v1/producer-product-categories/{{id}}/traffic-chart',
        methods: ['get'],
    },
    GROUPS: {
        URI: () => '/api/v1/producer-product-categories/{{id}}/producer-product-groups',
        methods: ['get'],
    },
});

export default {
    ...serviceFactory.build(ENDPOINTS),
};
